import { render, staticRenderFns } from "./Xieyi.vue?vue&type=template&id=7ce48f0f&scoped=true&"
import script from "./Xieyi.vue?vue&type=script&lang=js&"
export * from "./Xieyi.vue?vue&type=script&lang=js&"
import style0 from "./Xieyi.vue?vue&type=style&index=0&id=7ce48f0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce48f0f",
  null
  
)

export default component.exports